package com.eladfinish.bible.contest.screens.monopoly.usecases

import com.eladfinish.bible.contest.constants.Constants
import com.eladfinish.bible.contest.network.spreadsheet.SpreadsheetApi
import com.eladfinish.bible.contest.network.spreadsheet.handleApiResult
import com.eladfinish.bible.contest.network.spreadsheet.toSpreadsheetMatrix
import com.eladfinish.bible.contest.screens.monopoly.model.MonopolyItem
import com.eladfinish.bible.contest.screens.monopoly.model.MonopolyQA
import com.eladfinish.bible.contest.screens.monopoly.model.QuestionItemJsonKMP
import com.eladfinish.bible.contest.utils.spreadsheet.getId
import kotlinx.coroutines.flow.first
import kotlinx.coroutines.flow.map

class GetMonopolyDataUseCase(
    private val spreadsheetApi: SpreadsheetApi,
) {

    suspend fun getStatements(): Result<Pair<List<String>, List<String>>> =
        spreadsheetApi.getDataFromSpreadsheet(spreadsheetId = Constants.google_spreadsheet_monopoly_game.getId())
            .handleApiResult { result ->
                result.data.toSpreadsheetMatrix()
                    .map { list: List<List<String>> ->
                        list.map {
                            MonopolyItem(
                                type = it[0],
                                statement = it[1],
                            )
                        }
                    }
                    .map { list ->
                        list.partition { it.type == "קנס" }
                    }
                    .map { pair ->
                        pair.first.map { it.statement } to pair.second.map { it.statement }
                    }
                    .map {
                        Result.success(it)
                    }
                    .first()
            }

    suspend fun getQuestions(): Result<List<QuestionItemJsonKMP>> =
        spreadsheetApi.getDataFromSpreadsheet(spreadsheetId = Constants.google_spreadsheet_monopoly_game_questions.getId())
            .handleApiResult { result ->
                result.data.toSpreadsheetMatrix()
                    .map { list: List<List<String>> ->
                        list.map {
                            MonopolyQA(
                                question = it[0],
                                answer = it[1],
                            )
                        }
                    }
                    .map { list ->
                        list.map { QuestionItemJsonKMP(question = it.question, answer = it.answer) }
                    }
                    .map {
                        Result.success(it)
                    }
                    .first()
            }
}
